import { WithScope } from '@mews-commander/types';
import { createZodFormResolver, lt, showSuccessAlert, useFormControls } from '@mews/framework';
import { DropzoneField } from '@mews-commander/form';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useCurrentProfileId } from '@mews-commander/core';
import { FormLayout } from '../../FormLayout';
import { uploadReservationMembershipFile } from '../../../actions';
import { DownloadLink } from './DownloadLink';
import { ReservationMembershipFormKeys, ReservationMembershipFormSchema } from './types';

// @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'File[]'.ts(2322)
// delete this when we can reset the form also from the array see https://mews.atlassian.net/browse/DX-6346
const EMPTY_ARR: File[] = '';

export const ReservationMembershipForm = ({ scope, onSuccess }: WithScope & { onSuccess?: () => void }) => {
    const profileId = useCurrentProfileId();

    const dispatch = useCommanderThunkDispatch();
    const { renderFormContent, reset, isSubmitting } = useFormControls({
        onSubmit: async (v) => {
            await dispatch(uploadReservationMembershipFile({ groupId: scope, profileId, ...v })).then(() => {
                onSuccess?.();
                showSuccessAlert({ description: lt('Success') });
                reset();
            });
        },
        resolver: createZodFormResolver(ReservationMembershipFormSchema),
        defaultValues: {
            [ReservationMembershipFormKeys.files]: EMPTY_ARR,
        },
        dataTestForm: 'reservation-membership-form',
    });
    return renderFormContent(
        <FormLayout
            vertical
            loading={isSubmitting}
            submitButtonText={lt('Upload')}
            title={lt('RoomingList')}
            actions={<DownloadLink groupId={scope} />}
        >
            <DropzoneField
                data-test-id={ReservationMembershipFormKeys.files}
                name={ReservationMembershipFormKeys.files}
                label={lt('File')}
                accept=".xlsx"
                // Remove this comment for a better user experience after fix this https://mews.atlassian.net/browse/DX-6346
                // maxFilesLimit={1}
            />
        </FormLayout>
    );
};
